import { Pipe, PipeTransform } from '@angular/core';
import {PortfolioFilter} from './portfolio-filter';

@Pipe({
  name: 'filterPortfolio',
  pure: false
})

export class FilterPortfolio implements PipeTransform {

  transform(portfolios, filter?: PortfolioFilter): any {
    return portfolios.filter(
        portfolio =>
        (filter.Name == undefined || portfolio.Name.toLowerCase().startsWith(filter.Name.toLowerCase()) || (filter.Name.startsWith('%') && portfolio.Name.toLowerCase().indexOf(filter.Name.substring(1).toLowerCase()) > -1)) &&
        (filter.Desc == undefined || portfolio.Description.toLowerCase().startsWith(filter.Desc.toLowerCase()) || (filter.Desc.startsWith('%') && portfolio.Description.toLowerCase().indexOf(filter.Desc.substring(1).toLowerCase()) > -1)) &&
        (filter.Category == undefined || portfolio.Category.toLowerCase().startsWith(filter.Category.toLowerCase()) || (filter.Category.startsWith('%') && portfolio.Category.toLowerCase().indexOf(filter.Category.substring(1).toLowerCase()) > -1)) &&
        (filter.Year == undefined || portfolio.AYIdentifier.toLowerCase().startsWith(filter.Year.toLowerCase()) || (filter.Year.startsWith('%') && portfolio.AYIdentifier.toLowerCase().indexOf(filter.Year.substring(1).toLowerCase()) > -1)) &&
        (filter.AddBy == undefined || portfolio.AddedBy.toLowerCase().startsWith(filter.AddBy.toLowerCase()) || (filter.AddBy.startsWith('%') && portfolio.AddedBy.toLowerCase().indexOf(filter.AddBy.substring(1).toLowerCase()) > -1)) &&
        (filter.FromDate == undefined || filter.FromDate == '' || new Date(portfolio.Added) >= new Date(filter.FromDate)) &&
        (filter.ToDate == undefined || filter.ToDate == '' || new Date(portfolio.Added) <= new Date(filter.ToDate))
    );
  }
}
